import React, { Fragment } from 'react';
import ComponentErrorBoundary from '@/Layouts/ComponentErrorBoundary';
import { CustFormLabel } from '@/_elements/formLabel';
import { HiOutlineExternalLink } from 'react-icons/hi';
import { FaBook } from 'react-icons/fa';

function Component({ data, selectedCourses = [] }) {
    let parsedCourses = [];
    try {
        parsedCourses = typeof selectedCourses === 'string' ? JSON.parse(selectedCourses) : selectedCourses;
    } catch (e) {
        console.error('Failed to parse courses:', e);
    }

    return (
        <Fragment>
            {data?.trainings?.length ? (
                <div className="mt-3 border p-1 pt-0 px-2">
                    {parsedCourses?.length > 0 && (
                        <Fragment>
                            <CustFormLabel className="text-left text-bold my-2">
                                Courses
                                <FaBook size={12} className="ml-2" />
                            </CustFormLabel>
                            <div className="d-flex flex-wrap gap-3 ">
                                {parsedCourses.map((course, index) => (
                                    <a
                                        key={index}
                                        href={`/courses?course_id=${course.value}`}
                                        target="_blank"
                                        rel="noreferrer"
                                        className="d-inline-flex align-items-center gap-1 text-decoration-none border rounded px-3 py-2 mr-2 my-1"
                                        style={{ backgroundColor: '#f8f9fa' }}
                                    >
                                        {/* <FaBook size={14} className="mr-2" /> */}
                                        <span>{course.label}</span>
                                        <HiOutlineExternalLink size={14} className="ml-2" />
                                    </a>
                                ))}
                            </div>
                        </Fragment>
                    )}
                </div>
            ) : null}
        </Fragment>
    );
}

const EventTrainingCourses = (props) => (
    <ComponentErrorBoundary componentErrorMessage={props?.componentErrorMessage || 'Failed to load Event Location Map'}>
        <Component {...props} />
    </ComponentErrorBoundary>
);

export default EventTrainingCourses;
